<template>
  <div class="programming-dashboard-unit-loader">
    <content-loader
      :height="189"
      :width="530"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
    >
      <rect x="191.56" y="24.61" rx="0" ry="0" width="0" height="0" />
      <rect x="284.5" y="19.61" rx="0" ry="0" width="207.44" height="16.97" />
      <rect x="284.5" y="39.71" rx="0" ry="0" width="172.87" height="16.97" />
      <rect x="284.5" y="72.26" rx="0" ry="0" width="138.29" height="16.97" />
      <rect x="284.5" y="92.36" rx="0" ry="0" width="103.72" height="16.97" />
      <rect x="284.5" y="123.5" rx="0" ry="0" width="34.57" height="16.97" />
      <rect x="284.5" y="142.19" rx="0" ry="0" width="25.93" height="16.97" />
      <rect x="284.5" y="170.33" rx="0" ry="0" width="12.97" height="16.97" />
      <rect x="284.5" y="188.81" rx="0" ry="0" width="8.64" height="16.97" />
      <rect x="191.56" y="24.61" rx="0" ry="0" width="0" height="0" />
      <rect x="81.56" y="24.61" rx="0" ry="0" width="0" height="0" />
      <rect x="68.63" y="19.61" rx="0" ry="0" width="207.44" height="16.97" />
      <rect x="102.55" y="39.71" rx="0" ry="0" width="172.87" height="16.97" />
      <rect x="137.25" y="72.26" rx="0" ry="0" width="138.29" height="16.97" />
      <rect x="171.94" y="92.36" rx="0" ry="0" width="103.72" height="16.97" />
      <rect x="241.32" y="142.52" rx="0" ry="0" width="34.57" height="16.97" />
      <rect x="249.8" y="122.5" rx="0" ry="0" width="25.93" height="16.97" />
      <rect x="263.68" y="168.97" rx="0" ry="0" width="12.97" height="16.97" />
      <rect x="261.42" y="188.13" rx="0" ry="0" width="14.95" height="16.97" />
    </content-loader>
  </div>
</template>
<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'ProgrammingDashboardUnitLoader',
  components: {
    ContentLoader,
  },
};
</script>


// WEBPACK FOOTER //
// ProgrammingDashboardUnitLoader.vue?3be15ed8